import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { apiFetch } from "api/Api";
import { Link } from "react-router-dom";
import BASE_URL from "api/Api";
import "assets/theme/admin_list.css";
import { FaGraduationCap, FaPlus, FaSearch, FaEye, FaEdit, FaTrash } from "react-icons/fa";

const SchemeList = () => {
  const [schemes, setSchemes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 5;

  const fetchSchemes = async () => {
    try {
      const res = await apiFetch("leader_admin/get_all_schemes");
      setSchemes(res.data);
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this scheme?")) return;

    try {
      await apiFetch(`leader_admin/delete_scheme/${id}`, {
        method: "DELETE",
      });

      fetchSchemes();
    } catch (err) {
      alert(err.message);
    }
  };

  const filteredSchemes = schemes.filter((scheme) =>
    scheme.scheme_title?.toLowerCase().includes(search.toLowerCase())
  );
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

  const currentRecords = filteredSchemes.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  const totalPages = Math.ceil(filteredSchemes.length / recordsPerPage);

  useEffect(() => {
    fetchSchemes();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="admin-page-container">
        {/* Header */}
        <div className="admin-header-card d-flex align-items-center justify-content-between flex-wrap gap-3">
          <div className="d-flex align-items-center">
            <div className="admin-header-icon">
              <FaGraduationCap />
            </div>
            <div>
              <h4 className="admin-header-title">शासकीय योजना यादी (Scheme List)</h4>
              <p className="admin-header-subtitle mb-0">
                सर्व शासकीय योजनांची माहिती व्यवस्थापित करा आणि अपडेट करा
              </p>
            </div>
          </div>
          <Link to="/add_schemes" className="btn-admin-add">
            <FaPlus /> नवीन योजना जोडा
          </Link>
        </div>

        {/* Search */}
        <div className="admin-filter-card">
          <div className="admin-search-wrapper">
            <FaSearch className="admin-search-icon" />
            <input
              type="text"
              className="form-control admin-search-input"
              placeholder="योजना शोधा (Search Scheme Title)..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(1);
              }}
            />
          </div>
        </div>

        {/* Table Card */}
        <div className="admin-table-card">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-warning" role="status" />
              <p className="mt-2 text-muted fw-semibold">योजना लोड होत आहेत...</p>
            </div>
          ) : filteredSchemes.length === 0 ? (
            <div className="text-center py-5 text-muted">
              कोणतीही योजना आढळली नाही.
            </div>
          ) : (
            <>
              <div className="table-responsive">
                <table className="table table-admin-custom">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>योजना शीर्षक</th>
                      <th>प्रकार</th>
                      <th>कालावधी (Duration)</th>
                      <th>कागदपत्र</th>
                      <th className="text-end">कृती (Actions)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentRecords.map((scheme, index) => {
                      return (
                        <tr key={scheme.scheme_id}>
                          <td className="fw-bold text-secondary">
                            {indexOfFirstRecord + index + 1}
                          </td>

                          <td>
                            <div className="fw-bold text-dark">
                              {scheme.scheme_title}
                            </div>
                            <small className="text-muted text-truncate d-block" style={{ maxWidth: "350px" }}>
                              {scheme.description}
                            </small>
                          </td>

                          <td>
                            <span className="badge-status badge-status-info">
                              {scheme.scheme_type || "सामान्य"}
                            </span>
                          </td>

                          <td className="text-muted small">
                            {scheme.launch_date ? new Date(scheme.launch_date).toLocaleDateString("en-IN", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            }) : "—"}
                            {" ➔ "}
                            {scheme.end_date ? new Date(scheme.end_date).toLocaleDateString("en-IN", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            }) : "—"}
                          </td>

                          <td>
                            {scheme.document_path ? (
                              <a
                                href={`${BASE_URL}${scheme.document_path}`}
                                target="_blank"
                                rel="noreferrer"
                                className="btn-action-icon btn-action-view"
                                title="कागदपत्र पहा"
                              >
                                <FaEye />
                              </a>
                            ) : (
                              <span className="text-muted small">नाही</span>
                            )}
                          </td>

                          <td className="text-end">
                            <div className="admin-action-group justify-content-end">
                              <Link
                                to={`/edit_scheme/${scheme.scheme_id}`}
                                className="btn-action-icon btn-action-edit"
                                title="संपादित करा"
                              >
                                <FaEdit />
                              </Link>

                              <button
                                onClick={() => handleDelete(scheme.scheme_id)}
                                className="btn-action-icon btn-action-delete"
                                title="हटवा"
                              >
                                <FaTrash />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="admin-pagination-bar">
                <span className="admin-pagination-info">
                  {filteredSchemes.length} पैकी {indexOfFirstRecord + 1} ते{" "}
                  {Math.min(indexOfLastRecord, filteredSchemes.length)} दाखवत आहे
                </span>

                <div className="d-flex align-items-center gap-2">
                  <button
                    className="admin-pagination-btn"
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                  >
                    « मागील
                  </button>

                  {[...Array(totalPages)].map((_, index) => (
                    <button
                      key={index}
                      className={`admin-pagination-btn ${
                        currentPage === index + 1 ? "active" : ""
                      }`}
                      onClick={() => setCurrentPage(index + 1)}
                    >
                      {index + 1}
                    </button>
                  ))}

                  <button
                    className="admin-pagination-btn"
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage(currentPage + 1)}
                  >
                    पुढील »
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default SchemeList;